// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module__header___oGk9A","title":"styles-module__title___3TlSV","closeButton":"styles-module__closeButton___HPFuD","icon":"styles-module__icon___uNkOT"};